import { mapFromEntries } from './mapFromEntries';
/**
 * @since 0.5.19
 */
export function readonlyMapFromEntries(keyCodec, KO, valueCodec, name) {
    if (name === void 0) { name = "ReadonlyMap<" + keyCodec.name + ", " + valueCodec.name + ">"; }
    return mapFromEntries(keyCodec, KO, valueCodec, name);
}
